module.exports = __webpack_public_path__ + "img/device_example.ce853f8a.png";